import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("etms_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 423 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("etms_token");
      sessionStorage.setItem("maint_msg", errMsg(e));
      api.post("/auth/logout").finally(() => { if (window.location.pathname !== "/login") window.location.href = "/login"; });
    }
    if (e.response?.status === 401 && !e.config.url.includes("/auth/login")) {
      localStorage.removeItem("etms_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const PERMS = [
  ["inbox", "Kotak SMS (baca SMS)"],
  ["export_sms", "Ekspor SMS ke Excel"],
  ["transfer", "Cek Transfer"],
  ["ip_whitelist", "Atur IP kantor (whitelist)"],
  ["slots", "Peta Slot (lihat)"],
  ["slot_edit", "Beri nama, PT & nama massal"],
  ["check_balance", "Cek pulsa (per SIM)"],
  ["check_balance_all", "Cek semua saldo (sekaligus)"],
  ["switch_sim", "Ganti / aktifkan SIM"],
  ["send_sms", "Kirim SMS"],
  ["send_ussd", "Kirim USSD"],
  ["activity", "Riwayat aktivitas"],
  ["devices", "Device & Tailscale"],
  ["settings", "Kode operator"],
];

export const OPERATORS = {
  telkomsel: { label: "Telkomsel", short: "TSEL", color: "text-red-600" },
  indosat: { label: "Indosat", short: "ISAT", color: "text-yellow-600" },
  xl: { label: "XL/Axis", short: "XL", color: "text-sky-600" },
  tri: { label: "Tri", short: "TRI", color: "text-fuchsia-600" },
  smartfren: { label: "Smartfren", short: "SF", color: "text-pink-600" },
};

export const STATUS = {
  active: { label: "Aktif (Register OK)", tile: "bg-green-50 border-green-300", dot: "bg-[#22C55E]", text: "text-green-600" },
  inserted: { label: "Ada SIM (Card Inserted)", tile: "bg-slate-100 border-slate-300", dot: "bg-transparent ring-2 ring-inset ring-slate-400", text: "text-slate-700" },
  registering: { label: "Membaca kartu (Registering)", tile: "bg-green-50/50 border-green-300", dot: "bg-transparent ring-2 ring-inset ring-[#22C55E]", text: "text-green-600" },
  nobalance: { label: "Tanpa pulsa", tile: "bg-yellow-50 border-yellow-300", dot: "bg-[#EAB308]", text: "text-yellow-700" },
  lowbal: { label: "Pulsa rendah", tile: "bg-yellow-50 border-yellow-300", dot: "bg-[#EAB308]", text: "text-yellow-700" },
  standby: { label: "Tidak aktif", tile: "bg-white border-slate-200", dot: "hidden", text: "text-slate-500" },
  empty: { label: "Kosong", tile: "bg-white border-slate-200", dot: "hidden", text: "text-slate-400" },
  error: { label: "Error (Register Failed)", tile: "bg-red-50 border-red-300", dot: "bg-[#EF4444]", text: "text-red-600" },
};

export function slotState(s, low) {
  if (!s) return "empty";
  if (s.status === "active" && s.balance != null && s.balance < low) return "lowbal";
  return s.status || "empty";
}

export const rupiah = (n) => (n == null ? "—" : "Rp" + Number(n).toLocaleString("id-ID"));

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function ago(iso) {
  if (!iso) return "belum pernah";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "baru saja";
  if (m < 60) return `${m} mnt lalu`;
  if (m < 1440) return `${Math.round(m / 60)} jam lalu`;
  return `${Math.round(m / 1440)} hari lalu`;
}
